export default __webpack_public_path__ + "static/media/keySign.b6d4831b.svg";